import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PostListOrderByEnum } from '@tribeplatform/gql-client/types';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
import { ChevronDownIcon } from '@tribeplatform/react-ui-kit/icons';
import { T, useStaticIntl } from '../i18n';
export const postListOrdersFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            name: $t({
                id: 'PostList.PostListFilter.Latest',
                defaultMessage: 'Latest',
            }),
            value: PostListOrderByEnum.publishedAt,
        },
        {
            name: $t({
                id: 'PostList.PostListFilter.RecentActivity',
                defaultMessage: 'Recent activity',
            }),
            value: PostListOrderByEnum.lastActivityAt,
        },
        {
            name: $t({
                id: 'PostList.PostListFilter.MostReplied',
                defaultMessage: 'Most replied',
            }),
            value: PostListOrderByEnum.totalRepliesCount,
        },
        {
            name: $t({
                id: 'PostList.PostListFilter.MostReacted',
                defaultMessage: 'Most reacted',
            }),
            value: PostListOrderByEnum.reactionsCount,
        },
    ];
};
export const PostListFilter = ({ setOrderBy, orderBy }) => {
    var _a, _b;
    const listOrders = useStaticIntl(postListOrdersFactory);
    return (_jsx("div", { className: "flex justify-end pb-2 post-list-filter", children: _jsxs(Dropdown, { children: [_jsxs(Dropdown.ButtonMinimal, { className: "flex space-s-1 text-sm", children: [_jsxs("span", { children: [_jsx(T, { id: "Generics.SortBy", defaultMessage: "Sort by" }, void 0), ' ', _jsx("span", { className: "font-medium", children: (_b = (_a = listOrders.find(o => o.value === orderBy)) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase() }, void 0)] }, void 0), _jsx(ChevronDownIcon, { className: "w-4 h-4" }, void 0)] }, void 0), _jsx(Dropdown.Items, { children: listOrders.map(order => (_jsx(Dropdown.Item, { onClick: () => setOrderBy(order.value), children: order.name }, order.value))) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=PostListFilter.js.map